import {
  Home,
  ShoppingCart,
  Receipt,
  Payment,
} from '@material-ui/icons';

const backgroundColors = [
  'rgba(255, 99, 132, 0.5)',
  'rgba(54, 162, 235, 0.5)',
  'rgba(255, 206, 86, 0.5)',
  'rgba(75, 192, 192, 0.5)',
  'rgba(153, 102, 255, 0.5)',
  'rgba(255, 159, 64, 0.5)',
  'rgb(53, 162, 235, 0.5)',
];

const borderColors = [
  'rgba(255, 99, 132, 1)',
  'rgba(54, 162, 235, 1)',
  'rgba(255, 206, 86, 1)',
  'rgba(75, 192, 192, 1)',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)',
  'rgb(53, 162, 235, 1)',
];

const menus = [
  { key: 1, label: 'Home', type: 'home', icon: Home },
  { key: 2, label: 'Checks', type: 'checks', icon: ShoppingCart },
  { key: 3, label: 'Items', type: 'items', icon: Receipt },
  { key: 4, label: 'Payments', type: 'payment', icon: Payment },
];

export {
  backgroundColors,
  borderColors,
  menus,
};
